import { useState } from 'react'
import { Link } from 'react-router-dom'
import { Button, Input } from '@rb/ui'
import styles from './Auth.module.css'

export default function ForgotPassword() {
  const [email, setEmail] = useState('')
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    setLoading(true)
    try {
      await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      })
      setSubmitted(true)
    } finally {
      setLoading(false)
    }
  }

  if (submitted) {
    return (
      <div className={styles.card}>
        <h1 className={styles.heading}>E-Mail gesendet</h1>
        <p className={styles.success}>
          Wenn ein Konto mit dieser E-Mail-Adresse existiert, haben wir einen Link zum Zurücksetzen
          des Passworts gesendet. Bitte prüfen Sie Ihr Postfach.
        </p>
        <div className={styles.footer}>
          <Link to="/login" className={styles.link}>
            Zurück zur Anmeldung
          </Link>
        </div>
      </div>
    )
  }

  return (
    <div className={styles.card}>
      <h1 className={styles.heading}>Passwort vergessen</h1>
      <form onSubmit={handleSubmit} className={styles.form}>
        <Input
          type="email"
          label="E-Mail"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="email"
          required
        />
        <Button type="submit" disabled={loading} style={{ width: '100%' }}>
          {loading ? 'Wird gesendet…' : 'Link senden'}
        </Button>
      </form>
      <div className={styles.footer}>
        <Link to="/login" className={styles.link}>
          Zurück zur Anmeldung
        </Link>
      </div>
    </div>
  )
}
